import { defineMessages } from 'react-intl.macro';
import { TAG_FORM_TYPE } from '../constants';

export const tagFormTitleMessages = defineMessages<TAG_FORM_TYPE>({
  [TAG_FORM_TYPE.NEW]: {
    id: 'tagForm.title.new',
    defaultMessage: 'Nový štítek',
  },
  [TAG_FORM_TYPE.EDIT]: {
    id: 'tagForm.title.edit',
    defaultMessage: 'Detail štítku',
  },
});

export const tagFormFailMessages = defineMessages<TAG_FORM_TYPE>({
  [TAG_FORM_TYPE.NEW]: {
    id: 'tagForm.fail.new',
    defaultMessage: 'Vytvoření nového štítku se nepovedlo. Zkuste to prosím později.',
  },
  [TAG_FORM_TYPE.EDIT]: {
    id: 'tagForm.fail.edit',
    defaultMessage: 'Úpravy se nepovedlo uložit. Zkuste to prosím později.',
  },
});

export const tagFormBtnMessages = defineMessages({
  close: {
    id: 'tagForm.close',
    defaultMessage: 'Zavřít',
  },
  delete: {
    id: 'tagForm.delete',
    defaultMessage: 'Smazat',
  },
  cancel: {
    id: 'tagForm.cancel',
    defaultMessage: 'Zrušit změny',
  },
  save: {
    id: 'tagForm.save',
    defaultMessage: 'Uložit',
  },
  undo: {
    id: 'tagForm.undo',
    defaultMessage: 'Zpět na přehled štítků',
  },
  clear: {
    id: 'tagForm.clear',
    defaultMessage: 'Vyčistit',
  },
  create: {
    id: 'tagForm.create',
    defaultMessage: 'Vytvořit',
  },
});

export const tagFormMessages = defineMessages({
  nameLabel: {
    id: 'tagForm.name.label',
    defaultMessage: 'Název',
  },
  nameErrorMessage: {
    id: 'tagForm.name.errorMessage',
    defaultMessage: 'Vyplňte obsah štítku',
  },
  descriptionLabel: {
    id: 'tagForm.description.label',
    defaultMessage: 'Popis',
  },
  publishsetsLabel: {
    id: 'tagForm.publishsets.label',
    defaultMessage: 'Výdejní sady',
  },
  submitConfirmMessage: {
    id: 'tagForm.alert.submit.confirm',
    defaultMessage: 'Vaše změny nejsou uloženy. Přejete si přesto opustit stránku?',
  },
  tagAlertDelete: {
    id: 'tagForm.alert.delete',
    defaultMessage: 'Opravdu si přejete smazat štítek?',
  },
  isDefault: {
    id: 'tag.is_default',
    defaultMessage: 'Výchozí',
  },
});

export const tagFormQueryMessages = defineMessages({
  queryStateWaiting: {
    id: 'tagForm.query.load.waiting',
    defaultMessage: 'Čekejte prosím...',
  },
  loadQueryStateFail: {
    id: 'tagForm.query.load.fail',
    defaultMessage: 'Zobrazení informací o štítku se nepovedlo. Zkuste to prosím později.',
  },
  submitQueryStateSuccess: {
    id: 'tagForm.query.submit.success',
    defaultMessage: 'Úpravy uloženy.',
  },
  deleteQueryStateFail: {
    id: 'tagForm.query.delete.fail',
    defaultMessage: 'Smazání štítku se nepovedlo. Zkuste to prosím později.',
  },
});

export const tagListMessages = defineMessages({
  pageTitle: {
    id: 'tagList.PageTitle',
    defaultMessage: 'Přehled štítků',
  },
  queryStateWaiting: {
    id: 'tagList.state.waiting',
    defaultMessage: 'Seznam štítků se načítá.',
  },
  queryStateFail: {
    id: 'tagList.state.fail',
    defaultMessage: 'Seznam štítků se nepovedlo načíst.',
  },
  queryStateEmpty: {
    id: 'tagList.state.empty',
    defaultMessage: 'Seznam štítků je prázdný.',
  },
  tagCreated: {
    id: 'tagList.state.tagCreated',
    defaultMessage: 'Vytvoření nového štítku se povedlo.',
  },
  tagDeleted: {
    id: 'tagList.state.tagDeleted',
    defaultMessage: 'Štítek byl smazán.',
  },
  name: {
    id: 'tagList.name',
    defaultMessage: 'Název',
  },
  isDefault: {
    id: 'tagList.is_default',
    defaultMessage: 'Výchozí',
  },
  created: {
    id: 'tagList.created',
    defaultMessage: 'Vytvořeno',
  },
  edited: {
    id: 'tagList.edited',
    defaultMessage: 'Naposledy upraveno',
  },
  publishsetsCount: {
    id: 'tagList.publishsetsCount',
    defaultMessage: 'Počet přiřazených výdejních sad',
  },
  newTag: {
    id: 'tagList.newTag',
    defaultMessage: 'Vytvořit štítek',
  },
});
